import type { Crop, LoadCropVarietiesRequestType } from '@protector/entities/crop/models';
import type { UUID, V4Page } from '@protector/utils/types';

export const CropActionsTypes = {
  LOAD_CROP: '[Crop] Load Crop',
  LOAD_CROP_SUCCESS: '[Crop] Load Crop Success',
  LOAD_CROP_FAILURE: '[Crop] Load Crop Failure',

  LOAD_CROP_VARIETIES: '[Crop] Load Crop Varieties',
  LOAD_CROP_VARIETIES_SUCCESS: '[Crop] Load Crop Varieties Success',
  LOAD_CROP_VARIETIES_FAILURE: '[Crop] Load Crop Varieties Failure',

  LOAD_CROP_VARIETIES_PAGINATED_SUCCESS: '[Crop] Load Crop Varieties Paginated Success',
  LOAD_CROP_VARIETIES_PAGINATED_FAILURE: '[Crop] Load Crop Varieties Paginated Failure',

  LOAD_CROPS_BY_IDS: '[Crop] Load Crops by IDs',
  LOAD_CROPS_BY_IDS_SUCCESS: '[Crop] Load Crops by IDs Success',
  LOAD_CROPS_BY_IDS_FAILURE: '[Crop] Load Crops by IDs Failure',

  REMOVE_ALL_CROPS: '[Crop] Remove All Crops'
} as const;

export const LoadCrop = () => {
  return {
    type: CropActionsTypes.LOAD_CROP
  };
};

export const LoadCropSuccess = (cropPage: V4Page<Crop>) => {
  return {
    type: CropActionsTypes.LOAD_CROP_SUCCESS,
    payload: cropPage
  };
};

export const LoadCropFailure = (error: string) => {
  return {
    type: CropActionsTypes.LOAD_CROP_FAILURE,
    payload: error
  };
};

export const LoadCropVarieties = (request: LoadCropVarietiesRequestType) => {
  return {
    type: CropActionsTypes.LOAD_CROP_VARIETIES,
    payload: request
  };
};

export const LoadCropVarietiesPaginatedSuccess = (crops: Crop[]) => {
  return {
    type: CropActionsTypes.LOAD_CROP_VARIETIES_PAGINATED_SUCCESS,
    payload: crops
  };
};

export const LoadCropVarietiesPaginatedFailure = (error: string) => {
  return {
    type: CropActionsTypes.LOAD_CROP_VARIETIES_PAGINATED_FAILURE,
    payload: error
  };
};

export const LoadCropsByIds = (ids: UUID[]) => {
  return {
    type: CropActionsTypes.LOAD_CROPS_BY_IDS,
    payload: ids
  };
};

export const LoadCropsByIdsSuccess = (crops: Crop[]) => {
  return {
    type: CropActionsTypes.LOAD_CROPS_BY_IDS_SUCCESS,
    payload: crops
  };
};

export const LoadCropsByIdsFailure = (error: string) => {
  return {
    type: CropActionsTypes.LOAD_CROPS_BY_IDS_FAILURE,
    payload: error
  };
};

export const LoadRemoveAllCrops = () => {
  return {
    type: CropActionsTypes.REMOVE_ALL_CROPS
  };
};
